<template>
    <div>
        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="h7 pb-2">GENERAL</div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">

                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <div class="tw-text-4xl tw-uppercase tw-pt-0 tw-pb-1">CONTRACTS & RATES</div>
                </div>
                <div>
                    <div class="tw-text-1xl tw-uppercase tw-pt-1 tw-pb-2">IATSE 667 Agreements</div>
                    <a
                        class="tw-mb-2 tw-block contract_link"
                        v-for="contract in iatse_contracts_by_category.iatse667"
                        :key="contract.id"
                        :href="`/storage/contracts/${contract.file_name}`"
                        target="_blank"
                    >{{ contract.name }}</a>
                    <p class="description admin-generated" v-html="$root.sanitizeAndTruncateHTML(category_descriptions.contracts_iatse667_agreements_1, 1000)"></p>
                </div>
                <div>
                    <div class="tw-text-1xl tw-uppercase tw-pt-2 tw-pb-2">IATSE Agreements</div>
                    <a
                        class="tw-mb-2 tw-block contract_link"
                        v-for="contract in iatse_contracts_by_category.iatse"
                        :key="contract.id"
                        :href="`/storage/contracts/${contract.file_name}`"
                        target="_blank"
                    >{{ contract.name }}</a>
                    <p class="description" v-html="$root.sanitizeAndTruncateHTML(category_descriptions.contracts_iatse_agreements_1, 1000)"></p>
                </div>
            </div>
        </div>
        <div v-show="!isUserProducer" class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="h7 pb-2"><!-- Empty section title --></div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">

                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <div class="tw-text-4xl tw-uppercase tw-pt-2 tw-pb-4 sm:tw-pb-6">PRODUCTION CONTRACTS</div>

                </div>
                <div>
                    <smart-table
                        :headers="headers"
                        endpoint="productioncontract.list"
                        :options_payload="{only_active_productions:true}"
                        group-by="production.name"
                    >
                        <template v-slot:group.header="{ group, items, isOpen, toggle }">
                            <th :colspan="headers.length">
                                {{ group }}
                                <span v-if="items[0].production.alternate_name">
                                    ({{ items[0].production.alternate_name }})
                                </span>
                            </th>
                        </template>
                        <template v-slot:item.updated_at="{ isMobile, item, header, value, index}">
                            <a @click.prevent.stop="openAttachment(item)" class="contract_link">{{ item.name }}</a>
                        </template>
                    </smart-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
import SmartTable from "@/Generic/SmartTable.vue";

export default {
    name: "ContractsIndex",
    components: {SmartTable},
    layout: (h, page) => {
        return h(AppLayoutSidebarNav, [
            page
        ])
    },
    props: {
        'iatse_contracts': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'category_descriptions': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data: function () {
        return {
            iatse_contracts_by_category: {
                iatse667: [
                    this.iatse_contracts['collective_agreement'],
                    this.iatse_contracts['summary_rate_fringes_ia667'],
                    this.iatse_contracts['summary_rate_fringes_ia671'],
                ],
                iatse: [
                    this.iatse_contracts['low_budget'],
                    this.iatse_contracts['low_budget_canadian_667'],
                ]


            }
        }
    },
    computed: {
        headers() {
            return [
                {value: 'production.name',  text: 'Production',     align: `start`,  sortable: false,     filterable: false  },
                {value: 'contract.name',    text: 'Type',           align: `start`,  sortable: false,     filterable: false  },
                {value: 'status',           text: 'Status',         align: `start`,  sortable: false,     filterable: false  },
                {value: 'updated_at',       text: 'Latest Update',  align: `start`,  sortable: false,     filterable: false  },
            ]
        },
        isUserProducer() {
            if (this.$page.user.role === 'PRODUCER') {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        openAttachment(contract_record) {
            window.open(`/storage/productions/${contract_record.production_id}/${contract_record.file}`, '_blank').focus()
        },
    },
    mounted: function () {
        //
    }
}
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
.contract_link {
    color: #0000EE;
    text-decoration: underline;
    font-size: 0.8em !important;
}
.description {
    font-size: 0.7em;
}

.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
}

</style>
